import { render, staticRenderFns } from "./404.vue?vue&type=template&id=31c5ca2a&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.css?vue&type=style&index=0&id=31c5ca2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5ca2a",
  null
  
)

export default component.exports